var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAtendenteB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6217 15.1101C19.0539 15.7372 20.3408 16.6541 21.4012 17.8031C21.5619 17.9807 21.6533 18.2103 21.6586 18.4498V22.4095C21.6586 22.6721 21.5543 22.9239 21.3686 23.1095C21.183 23.2951 20.9312 23.3994 20.6687 23.3994H5.48992C5.22965 23.3995 4.97984 23.297 4.79457 23.1142C4.60929 22.9314 4.50347 22.683 4.5 22.4227V18.463C4.50207 18.219 4.59366 17.9841 4.75738 17.8031C5.81781 16.6541 7.10468 15.7372 8.53692 15.1101C9.96917 14.4829 11.5158 14.1592 13.0793 14.1592C14.6428 14.1592 16.1894 14.4829 17.6217 15.1101Z",
    fill: "#4D78AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0806 12.8388C15.6319 12.8388 17.7002 10.7706 17.7002 8.21922C17.7002 5.66788 15.6319 3.59961 13.0806 3.59961C10.5292 3.59961 8.46094 5.66788 8.46094 8.21922C8.46094 10.7706 10.5292 12.8388 13.0806 12.8388Z",
    fill: "#4D78AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAtendenteB);
export default __webpack_public_path__ + "static/media/LogoAtendenteB.e6b79cd3d6a73927f6cba31ed0f034d5.svg";
export { ForwardRef as ReactComponent };